/** Dedicated "tape is alive" signal for the market-session chip (SIG-378).
 *
 * TanStack dataUpdatedAt bumps on ANY successful fetch (REST polls included),
 * which made the observed-override report OPEN during the 4-5PM CT halt. The
 * pulse below is recorded ONLY when a real market_data.quote WS frame arrives,
 * so it proves live tape even while the user holds no positions.
 */

let lastQuotePulseAt: number | null = null;

export function recordQuotePulse(): void {
  lastQuotePulseAt = Date.now();
}

export function getLastQuotePulse(): number | null {
  return lastQuotePulseAt;
}

export function resetQuotePulseForTests(): void {
  lastQuotePulseAt = null;
}
